import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function Impressum() {
    return (
        <div className="max-w-3xl mx-auto px-6 py-16" data-testid="impressum-page">
            <Seo
                title="Mentions légales · Impressum · Foundation of Light"
                description="Mentions légales de Foundation of Light — Olivier Masurel, Einzelunternehmer, Cologne, Allemagne. USt-IdNr DE322124871."
                path="/mentions-legales"
                noindex
            />
            <p className="text-xs uppercase tracking-widest text-primary mb-3">Angaben gemäß § 5 TMG</p>
            <h1 className="font-serif text-4xl md:text-5xl mb-10">Mentions légales · Impressum</h1>

            <section className="space-y-2 mb-10">
                <h2 className="font-serif text-2xl mb-3">Éditeur du site</h2>
                <p><strong>Olivier Masurel</strong></p>
                <p>Einzelunternehmer (entrepreneur individuel)</p>
                <p>Zum Tilmeshof 63</p>
                <p>50859 Cologne (Köln)</p>
                <p>Allemagne · Deutschland</p>
            </section>

            <section className="space-y-2 mb-10">
                <h2 className="font-serif text-2xl mb-3">Contact</h2>
                <p>Téléphone : <a className="underline decoration-primary/40 underline-offset-4" href="tel:+4915756434770">+49 1575 6434 770</a></p>
                <p>Email : <a className="underline decoration-primary/40 underline-offset-4" href="mailto:info@foundation-of-light.com">info@foundation-of-light.com</a></p>
            </section>

            <section className="space-y-2 mb-10">
                <h2 className="font-serif text-2xl mb-3">Identifiant TVA</h2>
                <p>Numéro d'identification TVA intracommunautaire selon § 27 a UStG :</p>
                <p><strong>DE322124871</strong></p>
                <p className="text-sm text-muted-foreground mt-2">Statut Kleinunternehmer selon § 19 UStG — TVA non facturée.</p>
            </section>

            <section className="space-y-2 mb-10">
                <h2 className="font-serif text-2xl mb-3">Responsable du contenu · V.i.S.d.P.</h2>
                <p>Olivier Masurel · adresse ci-dessus</p>
                <p className="text-sm text-muted-foreground">Selon § 55 Abs. 2 RStV.</p>
            </section>

            <section className="space-y-2 mb-10">
                <h2 className="font-serif text-2xl mb-3">Règlement des litiges en ligne</h2>
                <p className="text-sm leading-relaxed">
                    La Commission européenne met à disposition une plateforme de règlement en ligne des litiges (RLL) :
                    {" "}
                    <a
                        href="https://ec.europa.eu/consumers/odr"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline decoration-primary/40 underline-offset-4"
                    >
                        https://ec.europa.eu/consumers/odr
                    </a>
                </p>
                <p className="text-sm text-muted-foreground mt-2">
                    Nous ne sommes ni disposés ni obligés à participer à une procédure de règlement des litiges devant une commission d'arbitrage des consommateurs.
                </p>
            </section>

            <section className="space-y-2 mb-10">
                <h2 className="font-serif text-2xl mb-3">Responsabilité pour les contenus</h2>
                <p className="text-sm leading-relaxed">
                    En tant que prestataire de services, nous sommes responsables du contenu propre de ce site conformément aux lois générales, selon § 7 al. 1 TMG.
                    Selon §§ 8 à 10 TMG, nous ne sommes toutefois pas tenus, en tant que prestataire de services, de surveiller les informations transmises ou stockées, ni de rechercher des circonstances indiquant des activités illégales.
                </p>
            </section>

            <section className="space-y-2 mb-10">
                <h2 className="font-serif text-2xl mb-3">Responsabilité pour les liens</h2>
                <p className="text-sm leading-relaxed">
                    Notre offre contient des liens vers des sites Web externes de tiers dont nous ne pouvons influencer le contenu.
                    Nous ne pouvons donc assumer aucune responsabilité pour ces contenus externes. Le fournisseur ou l'exploitant respectif du site est toujours responsable des contenus des sites liés.
                </p>
            </section>

            <section className="space-y-2">
                <h2 className="font-serif text-2xl mb-3">Droits d'auteur</h2>
                <p className="text-sm leading-relaxed">
                    Les contenus et œuvres créés par les exploitants du site sur ces pages sont soumis au droit d'auteur allemand.
                    La reproduction, l'édition, la diffusion et tout type d'exploitation en dehors des limites du droit d'auteur nécessitent l'accord écrit de l'auteur.
                </p>
            </section>

            <p className="text-xs text-muted-foreground mt-16">
                Voir aussi : <Link to="/cgv" className="underline decoration-primary/40 underline-offset-4">Conditions générales de vente</Link> · <Link to="/confidentialite" className="underline decoration-primary/40 underline-offset-4">Politique de confidentialité</Link>
            </p>
        </div>
    );
}
